module.exports = __webpack_public_path__ + "Ubisoft-plus-game-library-Ubisoft-Connect_desktop.png";